import { render, staticRenderFns } from "./403block.vue?vue&type=template&id=38734a0e&"
import script from "./403block.vue?vue&type=script&lang=js&"
export * from "./403block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports